/* eslint-disable eqeqeq */
import {
  all,
  call,
  fork,
  put,
  select,
  take,
  takeLatest,
} from 'redux-saga/effects';
import { FRAME_APP_MOUNTED } from '../../../actions/frameActions';
import { fetchCustState, putCustState } from '../../../actions/userActions';
import { getCmsProfile, getLanguage } from '../../../selectors/userSelectors';
import {
  getClosedSpeechBubbleCustState,
  getClosedSpeechBubbleLocalState,
} from '../selectors/configSelectors';

import { LOCATION_CHANGE } from 'connected-react-router';
import prismicApiClient from '../../../utils/prismicApi';
import {
  FETCH_CLOSED_SPEECH_BUBBLE_CUST_STATE_FAILURE,
  FETCH_CLOSED_SPEECH_BUBBLE_CUST_STATE_SUCCESS,
  FETCH_SPEECH_BUBBLE_FAILURE,
  FETCH_SPEECH_BUBBLE_SUCCESS,
  RECORD_CLOSED_SPEECH_BUBBLE,
  SET_CLOSED_SPEECH_BUBBLE_CUST_STATE,
  SET_CLOSED_SPEECH_BUBBLE_LOCAL_STATE,
  UPDATE_CLOSED_SPEECH_BUBBLE,
} from '../actions/chatbotAction';

// const SPEECH_BUBBLE_CLOSE_MODE_THREE_PERIOD = 259200000; // 259200000 = 1000 * 60 * 60 * 24 * 3
const SPEECH_BUBBLE_CLOSE_MODE_THREE_PERIOD = 1; // 259200000 = 1000 * 60 * 60 * 24 * 3
const SPEECH_BUBBLE_PLATFORM_CURRENT = 'WEB';
const SPEECH_BUBBLE_PLATFORM_ALL = 'ALL';
function* loadSpeechBubble() {
  try {
    // TODO: remove from profile api
    // const avatorsConfig = yield select(getAvatorsConfig);
    // const speechBubbleUrl =
    //   avatorsConfig.speechBubbleUrl + `&language=${language.toUpperCase()}`;
    const data = yield call(fetchSpeechBubble);
    if (!data || data.message) {
      throw new Error('unexpected speech bubble response');
    }
    if (
      !data ||
      !data.retrieveSpeechBubbleResponse ||
      !data.retrieveSpeechBubbleResponse.speechBubbleBanners
    ) {
      throw new Error('unexpected speech bubble response');
    }
    const combinedSpeechBubbleList =
      data.retrieveSpeechBubbleResponse.speechBubbleBanners;
    yield put({
      type: FETCH_SPEECH_BUBBLE_SUCCESS,
      payload: combinedSpeechBubbleList,
    });
  } catch (err) {
    console.error(err);
    yield put({ type: FETCH_SPEECH_BUBBLE_FAILURE });
  }
}
function* fetchSpeechBubble() {
  const cmsProfiles = (yield select(getCmsProfile)) || ['CWP'];
  const lang = (yield select(getLanguage)) || 'en';

  const speechBubbles = yield prismicApiClient
    .getSpeechBubbles({
      lang: lang,
      platform: 'portal',
      tags: cmsProfiles,
      limit: 15,
    })
    .call();

  // const res = await myAxaFetchWithToken(
  //   `${baseUrl}&device=WEB`,
  //   {
  //     method: 'GET',
  //     headers: {
  //       'x-axahk-msgid': `${uuidv4()}`,
  //     },
  //   },
  //   (options) => Promise.resolve(),
  // );
  return speechBubbles;
}

function* fetchClosedSpeechBubbleState() {
  try {
    //   const config = yield select(getClosedSpeechBubbleCustomApiConfig);
    const config = {
      key: 'closedSpeechBubbleV2',
      channel: 'emma',
    };
    const res = yield fetchCustState(config.key, config.channel);
    let closedSpeechBubbleCustValue: any = {};
    try {
      closedSpeechBubbleCustValue = JSON.parse(decodeURI(res));
    } catch (err) {
      console.error(err);
    }
    yield put({
      type: FETCH_CLOSED_SPEECH_BUBBLE_CUST_STATE_SUCCESS,
      payload: closedSpeechBubbleCustValue,
    });
    yield removeExpiredClosedBubbleFromCustState();
  } catch (e) {
    yield put({
      type: FETCH_CLOSED_SPEECH_BUBBLE_CUST_STATE_FAILURE,
      error: e,
    });
  }
}

function* pushClosedSbToCustState(sbObj: any) {
  const custState = yield select(getClosedSpeechBubbleCustState);
  // const config = yield select(getClosedSpeechBubbleCustomApiConfig);
  const config = {
    key: 'closedSpeechBubbleV2',
    channel: 'emma',
  };
  if (custState && sbObj) {
    yield put({ type: UPDATE_CLOSED_SPEECH_BUBBLE, payload: { sbObj } });
    const newCustState = yield select(getClosedSpeechBubbleCustState);
    yield putCustState(
      config.key,
      JSON.stringify(newCustState),
      config.channel,
      undefined,
      true,
    );
  }
}

function* pushClosedSbToLocalState(sbObj: any) {
  const localStateValue = yield select(getClosedSpeechBubbleLocalState);
  if (localStateValue && sbObj) {
    if (!localStateValue.find((sbo) => sbo && sbo.sbId === sbObj.sbId)) {
      localStateValue.push(sbObj);
    }

    yield put({
      type: SET_CLOSED_SPEECH_BUBBLE_LOCAL_STATE,
      payload: localStateValue,
    });
  }
}

function* recordClosedSpeechBubble(action) {
  try {
    const { closeMode, sbDetails } = action.payload;

    // dont store sbDetails, landingUrl might break the page
    const custStateObj = {
      sbId: sbDetails.sbId,
      closeTime: Date.now(),
      closeMode,
      platform: SPEECH_BUBBLE_PLATFORM_CURRENT,
      sbPageId: sbDetails.pageID,
      contentExtractRef: `${sbDetails.content?.slice(0, 50)}...`,
      // sbDetails,
    };

    switch (closeMode) {
      case '1': // forever mode
        // yield pushClosedSbToCustState(sbId);
        yield pushClosedSbToCustState(custStateObj);
        break;
      case '2': // login session mode, only required to keep in local state
        yield pushClosedSbToLocalState(custStateObj);
        break;
      case '3': // by time fix 72hrs
        yield pushClosedSbToCustState(custStateObj);
        break;
      case '4': // page mode (still need to add), only required to keep in local state
        yield pushClosedSbToLocalState(custStateObj);
        break;
      default:
        break;
    }
  } catch (err) {
    console.error(err);
  }
}

function* removeExpiredClosedBubbleFromCustState() {
  try {
    // wait untill closedSpeechBubbleList fetched
    const isFetchSuccess = yield waitForClosedSpeechBubbleCustState();
    if (!isFetchSuccess) {
      return;
    }

    // remove expired closed speech bubble
    const originalCustStateValue = yield select(getClosedSpeechBubbleCustState);
    const { closedSpeechBubble: originalClosedSpeechBubble = [] } =
      originalCustStateValue;
    const newClosedSpeechBubbleCustState = {
      closedSpeechBubble: [],
    };
    const currentTimestamp = Date.now();
    for (const sb of originalClosedSpeechBubble) {
      try {
        if (
          sb.platform === SPEECH_BUBBLE_PLATFORM_CURRENT ||
          sb.platform === SPEECH_BUBBLE_PLATFORM_ALL
        ) {
          // perform checking only to APP
          const isExpiredClosedSb = ifExpiredClosedSb(
            sb,
            currentTimestamp,
            '', // no need page id
            true,
          );

          if (isExpiredClosedSb) {
            continue;
          }
        }
        newClosedSpeechBubbleCustState.closedSpeechBubble.push(sb);
      } catch (err) {
        console.error(err);
      }
    }

    // push back to cust state
    // const config = yield select(getClosedSpeechBubbleCustomApiConfig);
    const config = {
      key: 'closedSpeechBubbleV2',
      channel: 'emma',
    };
    // const originalCustStateValueStr = JSON.stringify(originalCustStateValue);
    yield put({
      type: SET_CLOSED_SPEECH_BUBBLE_CUST_STATE,
      payload: newClosedSpeechBubbleCustState,
    });
    // const newCustStateValue = yield select(getClosedSpeechBubbleCustState);
    const newCustStateValueStr = JSON.stringify(newClosedSpeechBubbleCustState);
    yield putCustState(config.key, newCustStateValueStr, config.channel);
  } catch (err) {
    console.error(err);
    yield put({ type: FETCH_CLOSED_SPEECH_BUBBLE_CUST_STATE_FAILURE });
  }
}

function* removeExpiredClosedBubbleFromLocalState() {
  try {
    const localStateValue = yield select(getClosedSpeechBubbleLocalState);

    // get current page id
    const pageId = window.location.pathname
      .replace(/^\/([en|zh])+\/emma/gi, '')
      .toLowerCase();

    const currentTimestamp = Date.now();
    const newLocalStateValue = [];
    for (const sb of localStateValue) {
      try {
        if (
          sb.platform === SPEECH_BUBBLE_PLATFORM_CURRENT ||
          sb.platform === SPEECH_BUBBLE_PLATFORM_ALL
        ) {
          // perform checking only to APP
          const isExpiredClosedSb = ifExpiredClosedSb(
            sb,
            currentTimestamp,
            pageId,
            false,
          );
          if (isExpiredClosedSb) {
            continue;
          }
        }
        newLocalStateValue.push(sb);
      } catch (err) {
        console.error(err);
      }
    }

    // push back to local state
    yield put({
      type: SET_CLOSED_SPEECH_BUBBLE_LOCAL_STATE,
      payload: newLocalStateValue,
    });
  } catch (err) {
    console.error(err);
  }
}

function ifExpiredClosedSb(
  sb,
  currentTimestamp,
  currentPageId,
  isFromCustState,
) {
  switch (sb.closeMode) {
    case '1': // forever mode, in cust state
      if (!isFromCustState) return true; // remove from local state if exists
      return false;
    case '2': // login session mode, in local state, but will reset on new login session so return false
      if (isFromCustState) return true; // remove from cust state if exists
      return false;
    case '3': // 72hrs, in cust state
      if (!isFromCustState) return true; // remove from local state if exists
      if (!sb.closeTime) {
        return false;
      }
      if (
        currentTimestamp - sb.closeTime >
        SPEECH_BUBBLE_CLOSE_MODE_THREE_PERIOD
      ) {
        return true;
      }
      break;
    case '4': // page mode, in local state
      if (isFromCustState) return true; // remove from cust state if exists
      if (!currentPageId.match(new RegExp(sb.sbPageId, 'i'))) {
        return true;
      }
      break;
    default:
      return false;
  }
  return false;
}

function* waitForClosedSpeechBubbleCustState() {
  while (true) {
    const action = yield take([
      FETCH_CLOSED_SPEECH_BUBBLE_CUST_STATE_SUCCESS,
      FETCH_CLOSED_SPEECH_BUBBLE_CUST_STATE_FAILURE,
    ]);
    if (action.type === FETCH_CLOSED_SPEECH_BUBBLE_CUST_STATE_FAILURE) {
      return false;
    }
    if (action.type === FETCH_CLOSED_SPEECH_BUBBLE_CUST_STATE_SUCCESS) {
      return true;
    }
    return false;
  }
}
function* resetLocalState() {
  // reset to empty array
  yield put({ type: SET_CLOSED_SPEECH_BUBBLE_LOCAL_STATE });
}

function* onHomePageLoaded() {
  yield all([
    loadSpeechBubble(),
    fetchClosedSpeechBubbleState(),
    resetLocalState(),
  ]);
}

function* speechBubbleSaga() {
  yield take(FRAME_APP_MOUNTED);
  yield fork(onHomePageLoaded);
  yield takeLatest(RECORD_CLOSED_SPEECH_BUBBLE, recordClosedSpeechBubble);
  yield takeLatest(LOCATION_CHANGE, removeExpiredClosedBubbleFromLocalState);
}

export default speechBubbleSaga;
